import { Task } from '../../types';
import * as React from 'react';

type TooltipContext = (task?: Task, ref?: React.MutableRefObject<HTMLDivElement>) => void;

const TooltipContext = React.createContext<TooltipContext>(() => {});

export const TooltipProvider = ({ children }: { children: React.ReactNode }) => {
  const [task, setTask] = React.useState<Task | null>(null);
  const tooltipRef = React.useRef<HTMLDivElement>(null);
  const taskRef = React.useRef<HTMLDivElement>(null);

  const setTooltip = React.useCallback((task?: Task, ref?: React.MutableRefObject<HTMLDivElement>) => {
    if (ref) {
      taskRef.current = ref.current;
    }

    setTask(task);
  }, []);

  React.useEffect(() => {
    if (task && taskRef.current) {
      tooltipRef.current!.classList.remove('hidden');

      tooltipRef.current!.style.top = `${taskRef.current.offsetTop}px`;
    } else {
      tooltipRef.current!.classList.add('hidden');
    }
  }, [task]);

  return (
    <TooltipContext.Provider value={setTooltip}>
      <div className="hidden left-4 right-4 px-2 py-1 absolute pointer-events-none text-xs bg-black text-white -translate-y-full z-50" ref={tooltipRef}>
        {task && (
          <div>
            {task.title}
          </div>
        )}
      </div>
      {children}
    </TooltipContext.Provider>
  );
};

export const useTooltip = () => {
  return React.useContext(TooltipContext);
};
